<template>
  <div class="hp-manager-page-list">
    <filter-form :filter="filter" @handleSubmit="handleSubmit">
      <span slot="button" v-if="permission.find(a => a.name=='Announcement.Create')">
        <a-button type="primary" @click="handleEdit(0)">新增</a-button>
      </span>
      <span slot="button" v-if="permission.find(a => a.name=='Announcement.Publish')">
        <a-button type="primary" @click="batchPublish" :disabled="!hasSelected" :loading="loading">批量发布</a-button>
      </span>
    </filter-form>
    <standard-table ref="datas" size="default" :bordered="true" :columns="columns" :indentSize="15" :dataSource="datas" :pagination="pagination" :loading="loading" @tableChange="tableChange" :rowSelection="rowSelection">
      <template slot="selfactions" slot-scope="rowKey">
        <span>
          <a @click="handleEdit(1,rowKey.data)" :disabled="!permissionChecker('Announcement.Edit') ||  rowKey.data.status == 2">编辑</a>
          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">更多
              <a-icon type="down" />
            </a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a href="javascript:;" @click="handleEdit(2,rowKey.data)">详情</a>
              </a-menu-item>
              <a-menu-item>
                <a @click="handleScope(rowKey.data)" :disabled="!permissionChecker('AnnouncementScope.Query')">范围</a>
              </a-menu-item>
              <a-menu-item>
                <a href="javascript:;" @click="deldata(rowKey.data)" :disabled="!permissionChecker('Announcement.Delete')  ||  rowKey.data.status == 2">删除</a>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>
      </template>
    </standard-table>

    <!-- 新增修改弹窗 -->
    <hp-manager-modal :width="modalWidth" :title="title" v-model="addVisible">
      <hp-manager-page-announcement-add slot="slot" @submit-success="refreshCurrent" @cancel="addVisible = false" :params="params"></hp-manager-page-announcement-add>
    </hp-manager-modal>
    <hp-manager-modal :title="params.title+'  通知范围'" v-model="scopeListVisible" width="1000px">
      <hp-manager-page-announcementScope-list slot="slot" @submit-success="refreshCurrent" @cancel="scopeListVisible = false" :paramsX="params">
      </hp-manager-page-announcementScope-list>
    </hp-manager-modal>
  </div>
</template>

<script>
import { api } from "@/common";

import account from "@/mixins/account";
import dateFormat from "@/mixins/dateFormat";
import moneyFormat from "@/mixins/moneyFormat";
import { watch } from "fs";
import hpManagerPageAnnouncementAdd from "./Add";
import hpManagerPageAnnouncementScopeList from "./ScopeList";
import config from "@/config";
import { setTimeout } from "timers";

let announcementTypeOptions = [];
export default {
  mixins: [account, dateFormat, moneyFormat],
  components: {
    hpManagerPageAnnouncementAdd,
    hpManagerPageAnnouncementScopeList
  },
  data() {
    return {
      filter: [
        {
          type: "input",
          key: "title",
          name: "标题"
        },
        {
          type: "select",
          key: "announcementType",
          name: "类型",
          options: announcementTypeOptions
        }
      ],
      columns: [
        {
          title: "操作",
          dataIndex: "action",
          width: 120,
          scopedSlots: { customRender: "action" }
        },
        {
          title: "标题",
          dataIndex: "title",
          sorter: true
        },
        {
          title: "通知类型",
          width: 150,
          dataIndex: "announcementTypeStr"
        },
        {
          title: "是否置顶",
          width: 150,
          dataIndex: "isSticky",
          customRender: (text, row, index) => {
            return row.isSticky == true ? "是" : "否";
          }
        },
        {
          title: "置顶期",
          width: 200,
          dataIndex: "stickyBeginTime",
          customRender: (text, row, index) => {
            return row.isSticky == true
              ? this.formatDate(row.stickyBeginTime, "YYYY-MM-DD") +
                  " ~ " +
                  this.formatDate(row.stickyEndTime, "YYYY-MM-DD")
              : "";
          }
        },
        {
          title: "状态",
          width: 120,
          dataIndex: "statusStr"
        },
        {
          title: "修改时间",
          dataIndex: "creationTime",
          width: "10%",
          customRender: (text, row, index) => {
            return row.lastModificationTime != null
              ? this.formatDate(row.lastModificationTime, "YYYY-MM-DD HH:mm:ss")
              : this.formatDate(row.creationTime, "YYYY-MM-DD HH:mm:ss");
          }
        }
      ],
      datas: [],
      filterdata: Object.assign(
        {
          title: "",
          announcementType: ""
        },
        JSON.parse(JSON.stringify(config.pageFilter))
      ),
      pagination: JSON.parse(JSON.stringify(config.page)),
      params: {},
      addVisible: false,
      scopeListVisible: false,
      maxResultCount: config.page.pageSize,
      loading: false,
      pageSizeOptions: config.page.pageSizeOptions,
      modalWidth: "1000px",
      checkedRowKeys: [],
      checkedRows: [],
      permission: [],
      title: "",
      rowSelection: null
    };
  },
  async mounted() {
    this.permission = this.getPermission("Announcement");
    this.GetAnnouncementTypeOptions();
    this.getDatas(this.filterdata);
    this.rowSelection = {
      onChange: this.onSelectChange,
      getCheckboxProps: this.getCheckboxProps
    };
  },
  computed: {
    hasSelected() {
      return this.checkedRowKeys.length > 0;
    }
  },
  methods: {
    handleScope(record) {
      this.params = record;
      this.scopeListVisible = true;
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      let selected = [];
      selectedRows.forEach((element, index) => {
        selected.push(element.id);
      });
      this.checkedRowKeys = selected;
      this.checkedRows = selectedRows;
      this.rowSelection = {
        selectedRowKeys: selectedRowKeys,
        onChange: this.onSelectChange,
        getCheckboxProps: this.getCheckboxProps
      };
    },
    getCheckboxProps(record) {
      return {
        props: {
          disabled: record.status == 2 // Column configuration not to be checked
        }
      };
    },
    async GetAnnouncementTypeOptions() {
      let dictionary = await api.GetDictionaryForSelect({ type: 2 });
      if (dictionary) {
        announcementTypeOptions = [];
        dictionary.forEach(a => {
          announcementTypeOptions.push({
            name: a.text,
            val: a.value
          });
        });
      }
    },
    async batchPublish() {
      this.loading = true;
      let that = this;
      let request = { selectedIdList: this.checkedRowKeys };
      new Promise(async (resolve, reject) => {
        this.$confirm({
          title: "您确定要发布以下公告吗？",
          content: (
            <div>
              <br />
              {this.checkedRows.map(function(todo, index) {
                return <p>{index + 1 + "." + todo.title}</p>;
              })}
            </div>
          ),
          onOk() {
            that.doPublish(request);
          },
          onCancel() {}
        });
      });
      this.loading = false;
    },
    async doPublish(request) {
      let res = await api.BatchPublishAnnouncement(request);
      if (res) {
        this.$message.success("发布成功");
        this.refreshCurrent();
      }
    },
    handleSubmit(p) {
      this.pagination.current = 0;
      this.filterdata.title = p.values.title;
      this.filterdata.announcementType = p.values.announcementType;
      this.filterdata.skipCount = 0;
      this.filterdata.maxResultCount = this.maxResultCount;
      this.getDatas(this.filterdata);
    },
    //弹出编辑 详情 新增 模态框
    handleEdit(type, record) {
      this.isabl = false;
      if (type == 1) {
        this.title = "编辑公告";
      } else if (type == 2) {
        this.title = "公告详情";
        this.isabl = true;
      } else {
        this.title = "新增公告";
      }
      this.params = Object.assign({ isShow: this.isabl }, record);
      this.addVisible = true;
    },
    //删除数据
    async deldata(row) {
      let that = this;
      new Promise(async (resolve, reject) => {
        this.$confirm({
          title: "警告",
          content: "确定要删除此数据?",
          okText: "删除",
          centered: "centered",
          okType: "danger",
          cancelText: "取消",
          onOk() {
            that.delHandle(row);
          },
          onCancel() {
            console.log("Cancel");
          }
        });
      });
    },
    async delHandle(row) {
      let msgRet = await api.DelAnnouncement({ id: row.id });
      if (msgRet) {
        this.$message.success("删除成功");
        if (
          this.pagination.total - 1 <=
          this.pagination.pageSize * (this.pagination.current - 1)
        ) {
          this.filterdata.skipCount =
            this.pagination.current == 1
              ? 0
              : (this.pagination.current - 2) * this.maxResultCount;
          this.pagination.current =
            this.pagination.current == 1 ? 1 : this.pagination.current - 1;
        }
        this.getDatas(this.filterdata);
      }
    },

    refreshCurrent() {
      this.pagination.current = 0;
      this.addVisible = false;
      this.filterdata.skipCount = 0;
      this.filterdata.maxResultCount = this.maxResultCount;
      this.checkedRowKeys = [];
      this.rowSelection = {
        selectedRowKeys: [],
        onChange: this.onSelectChange,
        getCheckboxProps: this.getCheckboxProps
      };

      this.getDatas(this.filterdata);
    },
    tableChange(table) {
      if (table.page) {
        this.pagination.current = table.page.current;
        this.pagination.pageSize = table.page.pageSize;
        this.maxResultCount = table.page.pageSize;
        this.filterdata.skipCount =
          table.page.current == 1
            ? 0
            : (table.page.current - 1) * this.maxResultCount;
        this.filterdata.maxResultCount = table.page.pageSize;
      }
      if (table.filters.code && table.filters.code.length > 0) {
        console.log(table.filters);
      }
      if (table.sorter.field) {
        this.filterdata.sorting =
          table.sorter.field +
          " " +
          (table.sorter.order == "ascend" ? "asc" : "desc");
      }
      this.getDatas(this.filterdata);
    },

    async getDatas(options) {
      this.loading = true;
      let data = await api.GetAnnouncementList(options);
      this.datas = data.items;
      console.log(data);
      if (data) {
        this.pagination.total = data.totalCount;
        this.pagination.showTotal = bbb => `共有 ${data.totalCount} 条`;
        this.pagination.pageSize = this.maxResultCount;
      }
      this.loading = false;
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/router/Information/Announcement/List.vue